@if (authService.hasPermission(Permission.PostAssetsStatus)) {
  <app-products-recent-section
    title="Recently Reviewed"
    [products]="recentlyReviewedList"
    filter="RecentlyApprovedExternalEnhancement"
    (viewMore)="viewMore($event)"
  ></app-products-recent-section>
}
